import { Button } from "@src/components/ui-components/Buttons/Button/Button";
import { t } from "i18next";
import { Popup } from "../../../../../components/deprecated/Popup/Popup";
import { ReadAccessGroup, ReadAccessPopup } from "../../../../../components/deprecated/ReadAccessPopup/ReadAccessPopup";

import { Utilities } from "../../../../../utils/utilities";
import { ReadAccess } from "../../AccessData";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { DataObjectField, InputElementContext } from "../DataObjectField";

export class ReadAccessField<FirebaseDataType extends DataObjectType> extends DataObjectField<ReadAccess, FirebaseDataType> {
  accessGroups: ReadAccessGroup[];
  constructor(
    accessGroups: ReadAccessGroup[],
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => ReadAccess | ReadAccess[] | undefined,
    iconName?: string
  ) {
    super(key, title, dataGetter, iconName, false);
    this.accessGroups = accessGroups;
  }

  override singleInputElement = (value: ReadAccess | undefined, setValue: (value: ReadAccess | undefined) => void, context?: InputElementContext) => {
    let title = value ? Utilities.getReadAccessString(value) : "";
    return (
      <Button
        type="secondary"
        fullWidth
        title={title ? title + " (" + t("main.tapToEdit") + ")" : t("main.select")}
        onClick={() => {
          Popup.present((id) => (
            <ReadAccessPopup
              title={t("main.choose")}
              id={id}
              accessGroups={this.accessGroups}
              onSelect={(data) => setValue(data)}
              readAccess={value}
              context={{ propertyID: context?.propertyID }}
            />
          ));
        }}
      />
    );
  };

  getReadableStringRepresentation(value: ReadAccess): string {
    return Utilities.getReadAccessString(value);
  }
  encodeString = (value: ReadAccess) => value.toString();
  decodeString = (value: string) => Utilities.getReadAccess(JSON.parse(value));

  encode = (value: ReadAccess) => Utilities.convertReadAccess(value);
  decode = (value: any) => Utilities.getReadAccess(value);

  allComparators: DataObjectFieldComparator[] = ["equals", "not-equals", "is-known", "is-unknown"];

  override isValueValid = (value: any): boolean => {
    return typeof value === "object";
  };
}
